import { useClerk } from '@clerk/clerk-react';
import { Button } from '@/components/ui/button';
import { MessageCircle, LogOut } from 'lucide-react';
import Gleap from 'gleap';
import shomriLogo from '@/assets/shomri-logo.png';

const NoDeviceError = () => {
  const { signOut } = useClerk();

  const handleContactSupport = () => {
    Gleap.open();
  };

  const handleSignOut = async () => {
    // Clear device-related localStorage
    localStorage.removeItem('device_serial');
    localStorage.removeItem('selected_device_id');
    localStorage.removeItem('mentee_device_mode');
    
    await signOut();
  };

  return (
    <div className="min-h-[100dvh] flex flex-col items-center justify-center bg-gradient-to-b from-background to-muted/30 px-6">
      {/* Logo */}
      <img 
        src={shomriLogo} 
        alt="Shomri" 
        className="h-12 mb-8"
      />
      
      {/* Error content */}
      <div className="text-center max-w-sm">
        <h1 className="text-xl font-semibold mb-2 text-foreground">
          Device Not Found
        </h1>
        <p className="text-muted-foreground mb-8">
          We couldn't find a device associated with your account. 
          Please contact support for assistance.
        </p>
        
        {/* Actions */}
        <div className="flex flex-col gap-3">
          <Button 
            onClick={handleContactSupport}
            className="w-full"
          >
            <MessageCircle className="w-4 h-4 mr-2" />
            Contact Support
          </Button>
          
          <Button 
            variant="ghost" 
            onClick={handleSignOut}
            className="w-full text-muted-foreground"
          >
            <LogOut className="w-4 h-4 mr-2" />
            Sign Out
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NoDeviceError;
